
import React from "react";

const CategoryTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-card border-b border-border z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex gap-6 overflow-x-auto md:overflow-visible scrollbar-hide">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`relative py-3 text-sm md:text-base font-medium whitespace-nowrap transition-colors flex-shrink-0 border-b-2
                ${
                  activeTab === tab.id
                    ? "text-success border-success"
                    : "text-muted-foreground border-transparent"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryTabs;